import { render, staticRenderFns } from "./noOfficialAccount.vue?vue&type=template&id=41dc0d4a&scoped=true"
import script from "./noOfficialAccount.vue?vue&type=script&lang=js"
export * from "./noOfficialAccount.vue?vue&type=script&lang=js"
import style0 from "./noOfficialAccount.vue?vue&type=style&index=0&id=41dc0d4a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41dc0d4a",
  null
  
)

export default component.exports